import { render, staticRenderFns } from "./ShiftSessionsList.vue?vue&type=template&id=6915ccd6&"
import script from "./ShiftSessionsList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ShiftSessionsList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports